// /stores/modal.js
import { defineStore } from 'pinia';

export const useModalStore = defineStore('modal', {
  state: () => ({
    isModalVisible: false, // isModalOpen 대신 isModalVisible 사용
    modalType: 'alert',
    modalAlertOptions: {
      title: '',
      message: '',
      type: 'alert',
      confirmText: '확인',
      cancelText: '취소',
    },
    isEditView: false,
    customerInfo: null,
    resolvePromise: null,
    _resetTimer: null,
  }),

  getters: {
    // getter 이름 일관성 유지
    isModalOpen: (state) => state.isModalVisible, // 하위 호환성을 위한 alias
  },

  actions: {
    openModalAlert(options = {}) {
      return new Promise((resolve) => {
        if (this._resetTimer) {
          clearTimeout(this._resetTimer)
          this._resetTimer = null
        }
        this.isModalVisible = true;
        this.modalType = 'alert';
        this.modalAlertOptions = {
          // 기본값 먼저 (이전 값 승계 X)
          title: '',
          message: '',
          confirmText: '확인',
          cancelText: '취소',
          // options로 덮어쓰기
          ...options,
          type: 'alert',
        };
        this.resolvePromise = resolve;
      });
    },

    openModalConfirm(options = {}) {
      return new Promise((resolve) => {
        if (this._resetTimer) {
          clearTimeout(this._resetTimer)
          this._resetTimer = null
        }
        this.isModalVisible = true;
        this.modalType = 'confirm';
        this.modalAlertOptions = {
          title: '',
          message: '',
          confirmText: '확인',
          cancelText: '취소',
          ...options,
          type: 'confirm',
        };
        this.resolvePromise = resolve;
      });
    },

    openModalPopup() {
      this.isModalVisible = true;
      this.modalType = 'popup';
    },

    openModalNeedJoin() {
      this.isModalVisible = true;
      this.modalType = 'needJoin';
    },

    confirmModal() {
      if (this.resolvePromise) {
        this.resolvePromise(true);
        this.resolvePromise = null;
      }
      this.closeModalAlert();
    },

    cancelModal() {
      if (this.resolvePromise) {
        this.resolvePromise(false);
        this.resolvePromise = null;
      }
      this.closeModalAlert();
    },

    closeModalAlert() {
      this.isModalVisible = false;
      this.modalType = 'alert';
      
      // 약간의 지연 후 상태 초기화 (애니메이션 고려)
      this._resetTimer = setTimeout(() => {
        this._resetTimer = null
        this.modalAlertOptions = {
          title: '',
          message: '',
          type: 'alert',
          confirmText: '확인',
          cancelText: '취소',
        };
      }, 200);

      if (this.resolvePromise) {
        this.resolvePromise(false);
        this.resolvePromise = null;
      }
    },

    setIsEditView(value) {
      this.isEditView = value;
    },

    setCustomerInfo(info) {
      this.customerInfo = info;
    },

    // 디버깅용 메서드
    debugState() {
      console.log('Modal Store State:', {
        isModalVisible: this.isModalVisible,
        modalType: this.modalType,
        modalAlertOptions: this.modalAlertOptions,
      });
    },
  },
});